<template>
    <div>
        <div class="b-banner-box">
            <div class="b-banner-titlebg">
                <div class="b-banner-title">全渠道业务中台解决方案</div>
            </div>
        </div>
        <div class="b-title">业务架构</div>
        <div class="b-title2">Business Architecture</div>

        <div class="b-titlebox">
            <div class="b-titlebox-c">
                <div class="b-titlebox-ctitle">全渠道</div>
                <div class="b-titlebox-ctitle2">Omni-channel</div>
                <div class="b-titlebox-cline"></div>
                <img class="b-titleNum" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-title1.png" alt="">
            </div>
        </div>
        <div class="b-centre-box">
            <div class="b-centre-c">
                <div class="b-centre-cimgbg">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t1.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t1r.png" alt="">
                </div>
                <div>线下POS</div>
            </div>
            <div class="b-centre-c">
                <div class="b-centre-cimgbg">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t2.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t2r.png" alt="">
                </div>
                <div>PC Web</div>
            </div>
            <div class="b-centre-c">
                <div class="b-centre-cimgbg">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t3.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t3r.png" alt="">
                </div>
                <div>APP</div>
            </div>
            <div class="b-centre-c">
                <div class="b-centre-cimgbg">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t4.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t4r.png" alt="">
                </div>
                <div>Wechat</div>
            </div>
            <div class="b-centre-c">
                <div class="b-centre-cimgbg">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t5.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t5r.png" alt="">
                </div>
                <div>3rd Party</div>
            </div>
            <div class="b-centre-c">
                <div class="b-centre-cimgbg">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t6.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t6r.png" alt="">
                </div>
                <div>B2B Channel</div>
            </div>
            <div class="b-centre-c">
                <div class="b-centre-cimgbg" style="position:relative;top: 10px;">
                    <img class="b-centre-cimg b-centre-show" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t7.png" alt="">
                    <img class="b-centre-cimg b-centre-show2" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-channel-t7r.png" alt="">
                </div>
                <div style="position:relative;top: 7px;text-align: center">
                    <div>CCC</div>
                    <div style="font-size: 12px;">（Customer Care Center）</div>
                </div>
            </div>
        </div>

        <div class="b-titlebox">
            <div class="b-titlebox-c">
                <div class="b-titlebox-ctitle">业务中心</div>
                <div class="b-titlebox-ctitle2">Business Centre</div>
                <div class="b-titlebox-cline"></div>
                <img class="b-titleNum" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-title2.png" alt="">
            </div>
        </div>
        <div class="bc-hover">
            <div class="bc-hoverT-box">
                <div class="bc-hoverT-c1box">
                    <div class="bc-hoverT-box-z">
                        <div class="bc-hoverT-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t1.png" alt="">
                        </div>
                        <div class="bc-hoverT-ztext">订单中心</div>
                    </div>
                    <div class="bc-hoverT-box-f">
                        <div class="bc-hoverT-box-f-title">订单中心</div>
                        <div class="bc-hoverT-box-f-box">
                            <div class="bc-hoverT-box-f-boxc">订单获取</div>
                            <div class="bc-hoverT-box-f-boxc">订单路由</div>
                            <div class="bc-hoverT-box-f-boxc">订单查询</div>
                            <div class="bc-hoverT-box-f-boxc">订单履行</div>
                            <div class="bc-hoverT-box-f-boxc">订单校验</div>
                            <div class="bc-hoverT-box-f-boxc">订单分析</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverT-c2box">
                    <div class="bc-hoverT-box-z">
                        <div class="bc-hoverT-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t2.png" alt="">
                        </div>
                        <div class="bc-hoverT-ztext">菜单中心</div>
                    </div>
                    <div class="bc-hoverT-box-f" style="width: 180%;left: -40%;">
                        <div class="bc-hoverT-box-f-title">菜单中心</div>
                        <div class="bc-hoverT-box-f-box">
                            <div class="bc-hoverT-box-f-boxc">渠道管理</div>
                            <div class="bc-hoverT-box-f-boxc">菜单管理</div>
                            <div class="bc-hoverT-box-f-boxc">价格管理</div>
                            <div class="bc-hoverT-box-f-boxc">基础管理</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverT-c2box">
                    <div class="bc-hoverT-box-z">
                        <div class="bc-hoverT-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t3.png" alt="">
                        </div>
                        <div class="bc-hoverT-ztext">库存中心</div>
                    </div>
                    <div class="bc-hoverT-box-f" style="padding: 36px 20px;">
                        <div class="bc-hoverT-box-f-title">库存中心</div>
                        <div class="bc-hoverT-box-f-box">
                            <div class="bc-hoverT-box-f-boxc2" >逻辑库存分配</div>
                            <div class="bc-hoverT-box-f-boxc2">逻辑库存更新</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverT-c2box">
                    <div class="bc-hoverT-box-z">
                        <div class="bc-hoverT-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t4.png" alt="">
                        </div>
                        <div class="bc-hoverT-ztext">内容中心</div>
                    </div>
                    <div class="bc-hoverT-box-f">
                        <div class="bc-hoverT-box-f-title">内容中心</div>
                        <div class="bc-hoverT-box-f-box">
                            <div class="bc-hoverT-box-f-boxc">内容管理</div>
                            <div class="bc-hoverT-box-f-boxc">知识库</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverT-c2box">
                    <div class="bc-hoverT-box-z">
                        <div class="bc-hoverT-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t5.png" alt="">
                        </div>
                        <div class="bc-hoverT-ztext">门店订单中心</div>
                    </div>
                    <div class="bc-hoverT-box-f">
                        <div class="bc-hoverT-box-f-title">门店订单中心</div>
                        <div class="bc-hoverT-box-f-box">
                            <div class="bc-hoverT-box-f-boxc">订单预测</div>
                            <div class="bc-hoverT-box-f-boxc">订单订阅</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverT-c2box">
                    <div class="bc-hoverT-box-z">
                        <div class="bc-hoverT-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t6.png" alt="">
                        </div>
                        <div class="bc-hoverT-ztext">门店中心</div>
                    </div>
                    <div class="bc-hoverT-box-f">
                        <div class="bc-hoverT-box-f-title">门店中心</div>
                        <div class="bc-hoverT-box-f-box">
                            <div class="bc-hoverT-box-f-boxc">基础数据</div>
                            <div class="bc-hoverT-box-f-boxc">数据同步</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bc-hoverB-box">
                <div class="bc-hoverB-c2box">
                    <div class="bc-hoverB-box-z">
                        <div class="bc-hoverB-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t7.png" alt="">
                        </div>
                        <div class="bc-hoverB-ztext">支付中心</div>
                    </div>
                    <div class="bc-hoverB-box-f">
                        <div class="bc-hoverB-box-f-title">支付中心</div>
                        <div class="bc-hoverB-box-f-box">
                            <div class="bc-hoverB-box-f-boxc">支付服务</div>
                            <div class="bc-hoverB-box-f-boxc">对账服务</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverB-c2box">
                    <div class="bc-hoverB-box-z">
                        <div class="bc-hoverB-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t8.png" alt="">
                        </div>
                        <div class="bc-hoverB-ztext">交易中心</div>
                    </div>
                    <div class="bc-hoverB-box-f">
                        <div class="bc-hoverB-box-f-title">交易中心</div>
                        <div class="bc-hoverB-box-f-box">
                            <div class="bc-hoverB-box-f-boxc">交易服务</div>
                            <div class="bc-hoverB-box-f-boxc">购物车</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverB-c2box">
                    <div class="bc-hoverB-box-z">
                        <div class="bc-hoverB-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t9.png" alt="">
                        </div>
                        <div class="bc-hoverB-ztext">发票中心</div>
                    </div>
                    <div class="bc-hoverB-box-f">
                        <div class="bc-hoverB-box-f-title">发票中心</div>
                        <div class="bc-hoverB-box-f-box">
                            <div class="bc-hoverB-box-f-boxc">发票验证</div>
                            <div class="bc-hoverB-box-f-boxc">查询/开票</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverB-c2box">
                    <div class="bc-hoverB-box-z">
                        <div class="bc-hoverB-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t9.png" alt="">
                        </div>
                        <div class="bc-hoverB-ztext">客户中心</div>
                    </div>
                    <div class="bc-hoverB-box-f">
                        <div class="bc-hoverB-box-f-title">客户中心</div>
                        <div class="bc-hoverB-box-f-box">
                            <div class="bc-hoverB-box-f-boxc">会话管理</div>
                            <div class="bc-hoverB-box-f-boxc">信息维护</div>
                        </div>
                    </div>
                </div>
                <div class="bc-hoverB-c1box">
                    <div class="bc-hoverB-box-z">
                        <div class="bc-hoverB-zimg">
                            <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-t10.png" alt="">
                        </div>
                        <div class="bc-hoverB-ztext">活动营销中心</div>
                    </div>
                    <div class="bc-hoverB-box-f" style="padding: 20px;padding-bottom: 0;">
                        <div class="bc-hoverB-box-f-title">客户中心</div>
                        <div style="display:flex;align-items: center">
                            <div class="bc-hoverB-box-f-box">
                                <div class="bc-hoverB-box-f-boxc">市场计划</div>
                                <div class="bc-hoverB-box-f-boxc">活动内容</div>
                                <div class="bc-hoverB-box-f-boxc">活动创建</div>
                                <div class="bc-hoverB-box-f-boxc">活动执行</div>
                                <div class="bc-hoverB-box-f-boxc">规划引擎</div>
                                <div class="bc-hoverB-box-f-boxc">活动监控</div>
                            </div>
                            <div class="bc-hoverB-box-f-boxr">
                            营销分析
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="b-titlebox">
            <div class="b-titlebox-c">
                <div class="b-titlebox-ctitle">数据中心</div>
                <div class="b-titlebox-ctitle2">Data Centre</div>
                <div class="b-titlebox-cline"></div>
                <img class="b-titleNum" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-title3.png" alt="">
            </div>
        </div>
        <div class="b-data-box">
            <div class="b-data-boxc">
                <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-date-t1.png" alt="">
                <div class="b-data-boxc-title">数据能力</div>
                <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-date-icon.png" alt="">
                <div class="b-data-boxc-info">
                    <div class="b-data-boxc-infof" style="margin-bottom: 16px;">
                        <div style="width: 70px;text-align: center">元数据</div>
                        <div style="width: 70px;text-align: center">主数据</div>
                        <div style="width: 70px;text-align: center">数据实体</div>
                    </div>
                    <div class="b-data-boxc-infof">
                        <div style="width: 70px;text-align: center">数据规范</div>
                        <div style="width: 70px;text-align: center">数据安全</div>
                        <div style="width: 70px;text-align: center">数据质量</div>
                    </div>
                </div>
            </div>
            <div class="b-data-boxc">
                <img style="margin-bottom: 22px;position:relative;top: 22px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-date-t2.png" alt="">
                <div class="b-data-boxc-title">数据智能</div>
                <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-date-icon.png" alt="">
                <div class="b-data-boxc-info" style="box-sizing: border-box;padding: 0 40px;">
                    <div class="b-data-boxc-infof" style="margin-bottom: 16px;width: 100%;position:relative;top: 8px;">
                        <div style="width: 70px;text-align: center">用户画像</div>
                        <div style="width: 70px;text-align: center">算法模型</div>
                        <div style="width: 70px;text-align: center">战略模型</div>
                        <div style="width: 70px;text-align: center">机器模型</div>
                        <div style="width: 70px;text-align: center">推荐</div>
                    </div>
                    <div class="b-data-boxc-infof" style="margin-bottom: 16px;width: 100%;position:relative;top: 8px;">
                        <div style="width: 70px;text-align: center">数据分析</div>
                        <div style="width: 70px;text-align: center">智能风控</div>
                        <div style="width: 70px;text-align: center">营销分析</div>
                        <div style="width: 70px;text-align: center">机器学习</div>
                        <div style="width: 70px;text-align: center">...</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="b-titlebox">
            <div class="b-titlebox-c">
                <div class="b-titlebox-ctitle">基础能力</div>
                <div class="b-titlebox-ctitle2">Fundamental Capabilities</div>
                <div class="b-titlebox-cline"></div>
                <img class="b-titleNum" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-title4.png" alt="">
            </div>
        </div>
        <div class="b-basics-box">
            <div class="b-basics">
                <div class="b-basicst">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-basics-t1.png" alt="">
                </div>
                <div>物理库存</div>
            </div>
            <div class="b-basics">
                <div class="b-basicst">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-basics-t2.png" alt="">
                </div>
                <div>财务</div>
            </div>
            <div class="b-basics">
                <div class="b-basicst">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-basics-t3.png" alt="">
                </div>
                <div>任务管理</div>
            </div>
            <div class="b-basics">
                <div class="b-basicst">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-basics-t4.png" alt="">
                </div>
                <div>网络</div>
            </div>
            <div class="b-basics">
                <div class="b-basicst">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-basics-t5.png" alt="">
                </div>
                <div>计算能力</div>
            </div>
            <div class="b-basics">
                <div class="b-basicst">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-basics-t6.png" alt="">
                </div>
                <div>资源</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "retail-middle-ground"
    }
</script>

<style lang="less" scoped>
.b-banner-box{
    width: 100%;
    margin-top: 7px;
    height: 322px;
    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-banner.png") center center no-repeat;
    -webkit-background-size: auto 100%;
    background-size: auto 100%;
    display: flex;
    align-items: flex-end;
    margin-bottom: 50px;
    .b-banner-titlebg{
        width: 100%;
        height: 80px;
        background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/baner-tbg.png") center center no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        .b-banner-title{
            width: 1200px;
            height: 80px;
            font-size: 40px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
        }
    }
}
.b-title{
    margin-top: 50px;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
}
.b-title2{
    margin-top: 10px;
    font-size: 32px;
    font-weight: 300;
    text-align: center;
    margin-bottom: 72px;
}
.b-titlebox{
    display: flex;
    justify-content: center;
    .b-titlebox-c{
        position: relative;
        left: 60px;
        .b-titlebox-ctitle{
            font-size: 18px;
            font-weight: bold;
        }
        .b-titlebox-ctitle2{
            font-size: 15px;
        }
        .b-titlebox-cline{
            width: 1px;
            height: 35px;
            background: #D02024;
            position: absolute;
            left: -10px;
            top: 6px;
        }
        .b-titleNum{
            position: absolute;
            left: -83px;
            top: -25px;
            z-index: -1;
        }
    }
}
.b-centre-box{
    width: 1200px;
    margin: 39px auto 140px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .b-centre-c{
        cursor: pointer;
        width: 165px;
        height: 118px;
        background: #EEEEEE;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        transition: all .3s linear;
        .b-centre-cimgbg{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
            margin-bottom: 12px;
        }
        .b-centre-show{
            display: block;
        }
        .b-centre-show2{
            display: none;
        }
    }
    .b-centre-c:hover{
        background: #D02024;
        color: #fff;
        box-shadow: 0px 1px 21px 0px rgba(208, 32, 36, 0.48);
    }
    .b-centre-c:hover .b-centre-show{
        display: none;
    }
    .b-centre-c:hover .b-centre-show2{
        display: block;
    }
}
.bc-hover{
    width: 1200px;
    margin: 70px auto;
    height: 413px;
    background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/b-businessbg.png") no-repeat;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    .bc-hoverT-box{
        display: flex;
        width: 100%;
        height: 206px;
        border-bottom: 1px solid #fff;
        .bc-hoverT-c1box{
            width: 400px;
            height: 100%;
            position: relative;
        }

        .bc-hoverT-zimg{
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
        }
        .bc-hoverT-ztext{
            font-size: 16px;
            color: #fff;
        }
        .bc-hoverT-box-z{
            position: absolute;
            width: 100%;
            height: 100%;
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            transform:rotateY(0);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .bc-hoverT-box-f{
            position: absolute;
            z-index: 9999;
            top: -5%;
            left: -5%;
            width: 110%;
            height: 110%;
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            transform:rotateY(-180deg);
            background: #D02024;
            box-sizing: border-box;
            padding: 36px 38px;
            .bc-hoverT-box-f-title{
                font-size: 20px;
                color: #FFFFFF;
                margin-bottom: 30px;
            }
            .bc-hoverT-box-f-box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                .bc-hoverT-box-f-boxc{
                    width: 101px;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    margin-bottom: 20px;
                }
                .bc-hoverT-box-f-boxc2{
                    width: 100%;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    margin-bottom: 20px;
                }
            }
        }
        .bc-hoverT-c1box:hover .bc-hoverT-box-z{
            transform:rotateY(-180deg);
        }
        .bc-hoverT-c1box:hover .bc-hoverT-box-f{
            transform:rotateY(0deg);
        }
        .bc-hoverT-c2box{
            width: 160px;
            height: 100%;
            border-left: 1px solid #fff;
            box-sizing: border-box;
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            position: relative;
            z-index: 1;
        }
        .bc-hoverT-c1box:hover{
            z-index: 999999;
        }
        .bc-hoverT-c2box:hover{
            border-left: 1px solid rgba(0,0,0,0);
            z-index: 999999;
        }
        .bc-hoverT-c2box:hover .bc-hoverT-box-z{
            transform:rotateY(-180deg);
        }
        .bc-hoverT-c2box:hover .bc-hoverT-box-f{
            transform:rotateY(0deg);
        }
    }
    .bc-hoverB-box{
        display: flex;
        width: 100%;
        height: 206px;
        .bc-hoverB-c1box{
            width: 440px;
            height: 100%;
            position: relative;
        }
        .bc-hoverB-zimg{
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
        }
        .bc-hoverB-ztext{
            font-size: 16px;
            color: #fff;
        }
        .bc-hoverB-box-z{
            position: absolute;
            width: 100%;
            height: 100%;
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            transform:rotateY(0);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .bc-hoverB-box-f{
            position: absolute;
            z-index: 9999;
            top: -5%;
            left: -5%;
            width: 110%;
            height: 110%;
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            transform:rotateY(-180deg);
            background: #D02024;
            box-sizing: border-box;
            padding: 36px 50px;
            .bc-hoverB-box-f-title{
                font-size: 20px;
                color: #FFFFFF;
                margin-bottom: 30px;
            }
            .bc-hoverB-box-f-box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                .bc-hoverB-box-f-boxc{
                    width: 101px;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    margin-bottom: 20px;
                }
                .bc-hoverB-box-f-boxc2{
                    width: 100%;
                    height: 28px;
                    background: #FFFFFF;
                    border-radius: 14px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    margin-bottom: 20px;
                }
            }
            .bc-hoverB-box-f-boxr{
                width: 200px;
                height: 74px;
                background: #fff;
                margin-left: 14px;
                -webkit-border-radius: 14px;
                -moz-border-radius: 14px;
                border-radius: 14px;
                position: relative;
                bottom: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .bc-hoverB-c1box:hover .bc-hoverB-box-z{
            transform:rotateY(-180deg);
        }
        .bc-hoverB-c1box:hover .bc-hoverB-box-f{
            transform:rotateY(0deg);
        }
        .bc-hoverB-c2box{
            width: 190px;
            height: 100%;
            border-right: 1px solid #fff;
            box-sizing: border-box;
            transform-style: preserve-3d;
            backface-visibility:hidden;
            transition:all .5s;
            position: relative;
            z-index: 1;
        }
        .bc-hoverB-c1box:hover{
            z-index: 999999;
        }
        .bc-hoverB-c2box:hover{
            border-right: 1px solid rgba(0,0,0,0);
            z-index: 999999;
        }
        .bc-hoverB-c2box:hover .bc-hoverB-box-z{
            transform:rotateY(-180deg);
        }
        .bc-hoverB-c2box:hover .bc-hoverB-box-f{
            transform:rotateY(0deg);
        }
    }
}
.b-data-box{
    width: 1200px;
    margin: 80px auto 127px auto;
    display: flex;
    justify-content: space-between;
    .b-data-boxc{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .b-data-boxc-title{
            font-size: 26px;
            font-weight: bold;
            margin-top: 15px;
            margin-bottom: 10px;
        }
        .b-data-boxc-info{
            width: 542px;
            height: 98px;
            background: #EEEEEE;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .b-data-boxc-infof{
                width: 350px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 16px;
            }
        }
    }
}
.b-basics-box{
    width: 1200px;
    margin: 55px auto 100px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .b-basics{
        width: 78px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        .b-basicst{
            width: 78px;
            height: 78px;
            background: #626262;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 16px;
            transition: all .3s linear;
        }
        .b-basicst:hover{
            background: #D02024;
        }
    }
}
</style>